// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

// ==================== 旧页面重定向处理（必须在Vue初始化之前执行）====================
// 当访问旧版 .html 页面或搜索引擎收录的错误URL时，自动重定向到正确的 Vue 路由
(function() {
  // 获取当前URL信息
  const currentPath = window.location.pathname;
  const currentHash = window.location.hash;
  const host = window.location.host;
  
  // 定义有效路由路径（用于验证是否为Vue路由）
  const validRoutes = [
    '/school/intro', '/school/features', '/school/honors', '/school/competition', '/school/scenery', '/school/enterprise',
    '/organization/office', '/organization/admission', '/organization/students', '/organization/teaching', '/organization/logistics',
    '/majors/mechatronics', '/majors/newenergy', '/majors/livecommerce', '/majors/network', '/majors/medicallab', '/majors/nursing', '/majors/hotel', '/majors/beauty',
    '/advantages/youthleague', '/advantages/finance', '/advantages/management',
    '/teaching/management', '/teaching/training', '/teaching/research', '/teaching/report',
    '/admission/guide', '/admission/employment', '/admission/graduate',
    '/cooperation/overview', '/cooperation/enterprise', '/cooperation/school', '/cooperation/service', '/cooperation/international', '/cooperation/reservation',
    '/news/newsList', '/news/newsDetails',
    '/notice/noticeDetails'
  ];
  
  // 1. 处理旧版 .html 页面重定向
  const redirectMap = {
    '/xxgk.html': '/school/intro',
    '/zysz.html': '/majors/mechatronics',
    '/zsyjy.html': '/admission/guide',
    '/lxwm.html': '/cooperation/reservation'
  };
  
  if (redirectMap[currentPath]) {
    window.location.replace('http://' + host + '/#' + redirectMap[currentPath]);
    return;
  }
  
  // 2. 处理搜索引擎错误URL格式（pathname有路由路径，但hash为空或为#/）
  // 错误格式: http://domain.com/school/intro#/ 或 http://domain.com/school/intro
  // 正确格式: http://domain.com/#/school/intro
  if (currentPath !== '/' && validRoutes.includes(currentPath) && (currentHash === '' || currentHash === '#' || currentHash === '#/')) {
    const correctUrl = 'http://' + host + '/#' + currentPath;
    window.location.replace(correctUrl);
    return;
  }
  
  // 3. 处理混合模式URL（pathname已经有路径，hash也有路径）
  // 错误格式: http://domain.com/majors/mechatronics#/school/intro
  // 正确格式: http://domain.com/#/school/intro
  if (currentPath !== '/' && currentHash.startsWith('#/')) {
    const correctUrl = 'http://' + host + '/#' + currentHash.substring(1);
    window.location.replace(correctUrl);
    return;
  }
  
  // 4. 处理根路径但hash为空的情况（确保默认跳转到首页）
  if (currentPath === '/' && (currentHash === '' || currentHash === '#')) {
    window.location.replace('http://' + host + '/#/');
    return;
  }
})();

import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css';
import App from './App'
import router from './router'
import animated from 'animate.css'
import WOW from 'wowjs'
import './assets/iconfont/iconfont.css'
import VueTouch from 'vue-touchjs';
import "./styles/swiper.min.css";
import store from './store/store'
import "./styles/cover.css";
import axios from "axios";
import VueParticles from 'vue-particles'  
Vue.use(VueParticles)  


Vue.use(animated)
Vue.use(WOW)
Vue.prototype.$wow=WOW
Vue.use(ElementUI)
Vue.use(VueTouch);
Vue.prototype.$axios = axios

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({

  el: '#app',
  store,
  router,
  components: { App },
  template: '<App/>'
})




// WEBPACK FOOTER //
// ./src/main.js